const getFieldTypeColor = (fieldType: any): string | undefined => {
  switch (true) {
    case fieldType === 'integer':
      return 'success'
    case ['select', 'multiselect'].includes(fieldType):
      return 'warning'
    case fieldType === 'boolean':
      return 'error'
    case ['date', 'datetime'].includes(fieldType):
      return 'blue'
    default:
      return undefined
  }
}

export { getFieldTypeColor }
